import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Dashboard from "../components/dashboard/Dashboard";
import { useGetVendor } from "../hooks/vendors/Vendors";

function DashboardPage() {
  const { t } = useTranslation();

const {data} = useGetVendor();
const [name, setName] = useState('');


useEffect(() => {

  if (data) {
    setName(data.name);
  } 
}, [data]);


  return (
    <div id="vendorDashboard" style={ { minHeight: "70vh" }}>
      <div className="container globalDashboard v2">
        <div className="row">
          <div className="col-mg-12">
            {name && (
              <h4>{name + t("admin.dash.last")}</h4>
            )}
          </div>
        </div>
        <Dashboard />
      </div>
    </div>
  );
}

export default DashboardPage;
